import { Model } from '@vuex-orm/core';
import Activity from '@/models/Activity';
import Product from '@/models/Product';
import Zaui from '@/include/api';
import { mergeAllLocaleMessages } from '@/i18n';

export default class Package extends Model {
  static entity = 'packages';

  get routeName() {
    return this.type;
  }

  get imageUrl() {
    return this.image ? this.image : require('@/assets/images/abstract.png');
  }

  static fields() {
    return {
      type: this.string(),
      id: this.number(),
      name: this.string(),
      description: this.string(),
      image: this.string(),
      lang: this.attr(),
      category: this.number(),
      webSortPriority: this.number(),

      price: this.attr(),
      listPrice: this.attr(),
      shortDescription: this.string(),
      duration: this.attr(),
      isSingleDayOnly: this.attr(),
      isMultiDayItinerary: this.attr(),
      availability: this.attr(),
      activityIds: this.attr(),
      productIds: this.attr(),
      liveAvailability: this.attr(),

      activities: this.attr([]),
      products: this.attr([]),

      moreInfo: this.string(),
      policies: this.string(),
      pax: this.attr(),
      hasLunch: this.attr(),
      hasPickup: this.attr(),
      hasGiftCert: this.attr(),

      relatedProducts: this.attr(),
      relatedActivities: this.attr()
    };
  }

  static fetch(id, packageItem) {
    return Zaui.package.get(id, packageItem).then(data => {
      data.activityIds = [];
      var tempActivities = [];
      var tempProducts = [];

      if (data.activities) {
        data.activities.forEach(activity => {
          data.activityIds.push(activity.id);
          tempActivities.push(new Activity(activity));
        });
        data.activities = tempActivities;
      }

      data.productIds = [];
      if (data.products) {
        data.products.forEach(product => {
          data.productIds.push(product.id);
          tempProducts.push(new Product(product));
        });
        data.products = tempProducts;
      }

      Package.insert({ data });

      return data;
      // if (data.lang && data.lang.overrides) {
        // mergeAllLocaleMessages(data.lang.overrides);
      // }
    });
  }

  static fetchList(category, date) {
    return Zaui.package.list(category, date).then(data => {
      Package.insert({ data });
    });
  }

  static beforeCreate(model) {
    if (model.lang) {
      mergeAllLocaleMessages(model.lang);
    }
  }

}